export const RadioItem = ({
  label,
  checked,
  onChange,
}: {
  value: string;
  label: string;
  checked: boolean;
  onChange: () => void;
}) => (
  <label className="group flex cursor-pointer items-center py-2.5">
    <div className="relative flex items-center justify-center">
      <input
        type="radio"
        name="speciality-category"
        className="checked:border-theme-action-primary h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-300 transition-all"
        checked={checked}
        onChange={onChange}
      />
      {checked && (
        <div className="bg-theme-action-primary absolute h-2.5 w-2.5 rounded-full" />
      )}
    </div>
    <span
      className={`ml-3 text-[15px] ${checked ? 'text-theme-action-primary font-medium' : 'text-theme-dark-deep'}`}
    >
      {label}
    </span>
  </label>
);
